exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flex-f515293b{display:flex}.flex-f515293b .codeInput-ac32bb2f{width:200px;margin-right:10px}.CodePicker-354c7925{margin-top:20px;margin-right:50px}.generate-d3f4acaf{margin:10px 0px}.generate-d3f4acaf a.generateUnlimited-5fe07737{padding:0px;text-align:left}.qrCodes-97294a8c{display:flex}.qrCodes-97294a8c>div:first-child{margin-right:100px}\n", ""]);

// Exports
exports.locals = {
	"flex": "flex-f515293b",
	"codeInput": "codeInput-ac32bb2f",
	"CodePicker": "CodePicker-354c7925",
	"generate": "generate-d3f4acaf",
	"generateUnlimited": "generateUnlimited-5fe07737",
	"qrCodes": "qrCodes-97294a8c"
};